import React from 'react'
import Header from './Components/Header'
import Main from './Components/Main'
import Favourite from './Components/Favourite'
import Footer from './Components/Footer'
import {  DNA } from 'react-loader-spinner'

const Home = () => {
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        setTimeout(() => {
            setLoading(false)
        }, 3000)
    }, [])

    if (loading) {
        return (
            <>
                <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <DNA
                        visible={true}
                        height="80"
                        width="80"
                        ariaLabel="dna-loading"
                        wrapperStyle={{}}
                        wrapperClass="dna-wrapper"
                    />
                </div>
            </>
        )
    }
    return (
        <>
            <Header />
            <Main />
            <Favourite />
            <Footer />
        </>
    )
}

export default Home

